const SvelteLoader = () => {
    return <div className="svelte_loader"/>
}

export default SvelteLoader
